import * as React from 'react';
export var SiteSidebarContext = React.createContext({
  showFullscreenButton: false,
  isAvailable: false
});
export var SiteSidebarProvider = SiteSidebarContext.Provider;